export default {
  participanttype: 'Type de participant',
  participanttypes: 'Types de participants',
  verbose_participanttype: 'un type de participant',

  select_participanttype: 'Sélectionner un type de participant',
};
